// extracted by mini-css-extract-plugin
export default {"NotFoundHeader":"wU7g7"};